import {useSelector} from 'react-redux';

export default ({
                    src = '',
                    status = true,
                    ...props
                }) => {
    const ThemeState = useSelector(state => state.Theme.theme)

    try {
        let splitUrl = src.split('/')
        splitUrl[splitUrl.length - 1] = `dark/${splitUrl[splitUrl.length - 1]}`

        if (ThemeState === 'dark')
            return <img src={splitUrl.join('/')} {...props} />

        return <img src={src} {...props} />
    } catch (e) {
        return <img src={src} {...props} />
    }
}